var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Toolbar',{attrs:{"handle-delete":_vm.del,"handle-reset":_vm.resetForm,"handle-submit":_vm.onSendForm}}),(_vm.item)?_c('BackendGroupForm',{ref:"updateForm",attrs:{"errors":_vm.violations,"values":_vm.item}}):_vm._e(),_c('Loading',{attrs:{"visible":_vm.isLoading || _vm.deleteLoading}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }